export const addUTMParams = (url: string | undefined, utmSource: string, utmMedium: string, utmCampaign: string) => {
  if (!url) {
    return "";
  }
  const delimiter = url.includes('?') ? '&' : '?';
  return `${url}${delimiter}utm_source=${utmSource}&utm_medium=${utmMedium}&utm_campaign=${utmCampaign}`;
};